import type { PermissionCode } from "@tm-food/api-contract";
import { PermissionCodes } from "@tm-food/api-contract";

export { PermissionCodes, RoleCodes, type PermissionCode, type RoleCode } from "@tm-food/api-contract";

/** Normalize permission codes to BE dot-form (`sales.manage`). */
export function normalizePermission(code: string): string {
  return code.trim().replace(/:/g, ".").toLowerCase();
}

export function normalizePermissions(codes: readonly string[]): string[] {
  const out = new Set<string>();
  for (const code of codes) {
    const n = normalizePermission(code);
    if (n) out.add(n);
  }
  return [...out];
}

export function hasPermission(
  granted: readonly string[],
  required: PermissionCode | string | readonly (PermissionCode | string)[],
): boolean {
  const set = new Set(normalizePermissions(granted));
  const need = Array.isArray(required) ? required : [required];
  return need.every((p) => set.has(normalizePermission(p)));
}

export function hasAnyPermission(
  granted: readonly string[],
  required: readonly (PermissionCode | string)[],
): boolean {
  const set = new Set(normalizePermissions(granted));
  return required.some((p) => set.has(normalizePermission(p)));
}

/** All known permission codes (BE catalog mirror). */
export const ALL_PERMISSION_CODES: readonly PermissionCode[] =
  Object.values(PermissionCodes);
